import { render, staticRenderFns } from "./stat-card.vue?vue&type=template&id=507af1d3&scoped=true&"
import script from "./stat-card.vue?vue&type=script&lang=js&"
export * from "./stat-card.vue?vue&type=script&lang=js&"
import style0 from "./stat-card.vue?vue&type=style&index=0&id=507af1d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507af1d3",
  null
  
)

export default component.exports